import { observer } from "mobx-react";
import * as React from "react";
import { Button, Classes, Dialog, FormGroup, HTMLSelect, Icon, InputGroup } from "@blueprintjs/core";
import { observable } from "mobx";
import { MDBCol, MDBRow } from "mdbreact";
import { LoginStore } from "../../stores/login/LoginStore";
import { AppStore } from "../../stores/AppStore";
import { validarCNPJ } from "../../utils";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
const InputMask = require("react-input-mask");

@observer
export class CreateContaPage extends React.Component<{}, {}>{
    obs = observable({
        formErrors: [] as any,
        loading: false as boolean
    })

    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
      
      LoginStore.obs.email = ""
      LoginStore.obs.razao_social = ""
      LoginStore.obs.cnpj = ""
      LoginStore.obs.telefone = ""
      LoginStore.obs.cep = ""
      LoginStore.obs.rua = ""
      LoginStore.obs.bairro = ""
      LoginStore.obs.complemento = ""
      LoginStore.obs.numero = ""
      LoginStore.obs.cidade = ""
      LoginStore.obs.estado = ""
      LoginStore.obs.pessoa_nome = ""
      LoginStore.obs.pessoa_email = ""
      LoginStore.obs.pessoa_cpf = ""
      LoginStore.obs.pessoa_nascimeto = ""
      LoginStore.obs.pessoa_cep = ""
      LoginStore.obs.pessoa_rua = ""
      LoginStore.obs.pessoa_bairro = ""
      LoginStore.obs.pessoa_numero = ""
      LoginStore.obs.pessoa_cidade = ""
      LoginStore.obs.pessoa_estado = ""
      LoginStore.obs.termos = false
      LoginStore.obs.acomar = false
      LoginStore.obs.representante_id = ""

    }

    async handlePessoaCep(cep: string) {

      let new_cep = (cep.match(/\d+/g) || []).join("")

        LoginStore.obs.pessoa_cep = new_cep

        if (new_cep.length == 8) {
            let resp = await LoginStore.handleGetCep(new_cep)

            LoginStore.obs.pessoa_bairro = resp.bairro
            LoginStore.obs.pessoa_cidade = resp.cidade
            LoginStore.obs.pessoa_rua = resp.logradouro
            LoginStore.obs.pessoa_estado = resp.uf
        }
    }

    async handleCep(cep: string) {
        let new_cep = (cep.match(/\d+/g) || []).join("")

        LoginStore.obs.cep = new_cep

        if (new_cep.length == 8) {
            let resp = await LoginStore.handleGetCep(new_cep)

            LoginStore.obs.bairro = resp.bairro
            LoginStore.obs.cidade = resp.cidade
            LoginStore.obs.rua = resp.logradouro
            LoginStore.obs.estado = resp.uf
        }
    }

    async handleContinuar() {
        this.obs.loading = true

        let isValided = this.handleValid()

        if (isValided) {
            let params = {
                email: LoginStore.obs.email,
                razao_social: LoginStore.obs.razao_social,
                cnpj: LoginStore.obs.cnpj,
                telefone: LoginStore.obs.telefone,
                cep: LoginStore.obs.cep,
                logradouro: LoginStore.obs.rua,
                bairro: LoginStore.obs.bairro,
                complemento: LoginStore.obs.complemento,
                numero: LoginStore.obs.numero,
                cidade: LoginStore.obs.cidade,
                estado: LoginStore.obs.estado,
                nome: LoginStore.obs.pessoa_nome,
                email_pessoa: LoginStore.obs.pessoa_email,
                cpf_pessoa: LoginStore.obs.pessoa_cpf,
                nascimento: LoginStore.obs.pessoa_nascimeto,
                cep_pessoa: LoginStore.obs.pessoa_cep,
                endereco_pessoa: LoginStore.obs.pessoa_rua,
                bairro_pessoa: LoginStore.obs.pessoa_bairro,
                numero_pessoa: LoginStore.obs.pessoa_numero,
                cidade_pessoa: LoginStore.obs.pessoa_cidade,
                estado_pessoa: LoginStore.obs.pessoa_estado,
                termos: LoginStore.obs.termos,
                acomar: LoginStore.obs.acomar,
                representante_id: LoginStore.obs.representante_id,
            }

            let res = await LoginStore.handleCreateConta(params)

            if (res.ok) {
                LoginStore.obs.conta_id = res.id
                this.obs.loading = false
                return AppStore.setLocation("/conta/usuario");
            } else {
                this.obs.formErrors.cnpj = "CNPJ já Cadastrado!"
            }
        }

        this.obs.loading = false
    }

    handleValid() {
        let err: any = {}

        if (LoginStore.obs.razao_social == "") {
            err.razao_social = "Razão Social obrigatório!"
        }
        if (LoginStore.obs.cnpj == "") {
            err.cnpj = "CNPJ obrigatório!"
        } else {
            if (!validarCNPJ(LoginStore.obs.cnpj)) {
                err.cnpj = "CNPJ inválido!"
            }
        }
        if (LoginStore.obs.telefone == "") {
            err.telefone = "Telefone obrigatório!"
        }
        if (LoginStore.obs.cep == "") {
            err.cep = "CEP obrigatório!"
        }
        if (LoginStore.obs.rua == "") {
            err.rua = "Rua obrigatório!"
        }
        if (LoginStore.obs.bairro == "") {
            err.bairro = "Bairro obrigatório!"
        }
        if (LoginStore.obs.numero == "") {
            err.numero = "Número obrigatório!"
        }
        if (LoginStore.obs.cidade == "") {
            err.cidade = "Cidade obrigatório!"
        }
        if (LoginStore.obs.estado == "") {
            err.estado = "Estado obrigatório!"
        }
        if (LoginStore.obs.pessoa_nome == "") {
            err.pessoa_nome = "Nome obrigatório!"
        }
        if (LoginStore.obs.pessoa_rua == "") {
            err.pessoa_rua = "Rua obrigatório!"
        }
        if (LoginStore.obs.pessoa_cep == "") {
            err.pessoa_cep = "CEP obrigatório!"
        }
        if (LoginStore.obs.pessoa_bairro == "") {
            err.pessoa_bairro = "Bairro obrigatório!"
        }
        if (LoginStore.obs.pessoa_numero == "") {
            err.pessoa_numero = "Número obrigatório!"
        }
        if (LoginStore.obs.pessoa_cidade == "") {
            err.pessoa_cidade = "Cidade obrigatório!"
        }
        if (LoginStore.obs.pessoa_estado == "") {
            err.pessoa_estado = "Estado obrigatório!"
        }
        if (LoginStore.obs.pessoa_cpf == "") {
            err.pessoa_cpf = "CPF obrigatório!"
        }
        if (LoginStore.obs.pessoa_nascimeto == "") {
            err.pessoa_nascimeto = "Data de Nascimento obrigatório!"
        }
        if (LoginStore.obs.pessoa_email == "") {
            err.pessoa_email = "E-mail obrigatório!"
        } else {
            let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            if (!regex.test(LoginStore.obs.pessoa_email)) {
                err.pessoa_email = "E-mail inválido!"
            }
        }

        this.obs.formErrors = err
        return Object.keys(err).length < 1;
    }

    render() {
        let estadosOption = [
            { label: "Selecione", value: "" },
            { label: "Acre", value: "AC" },
            { label: "Alagoas", value: "AL" },
            { label: "Amapá", value: "AP" },
            { label: "Amazonas", value: "AM" },
            { label: "Bahia", value: "BA" },
            { label: "Ceará", value: "CE" },
            { label: "Distrito Federal", value: "DF" },
            { label: "Espírito Santo", value: "ES" },
            { label: "Goiás", value: "GO" },
            { label: "Maranhão", value: "MA" },
            { label: "Mato Grosso", value: "MT" },
            { label: "Mato Grosso do Sul", value: "MS" },
            { label: "Minas Gerais", value: "MG" },
            { label: "Pará", value: "PA" },
            { label: "Paraíba", value: "PB" },
            { label: "Paraná", value: "PR" },
            { label: "Pernambuco", value: "PE" },
            { label: "Piauí", value: "PI" },
            { label: "Rio de Janeiro", value: "RJ" },
            { label: "Rio Grande do Norte", value: "RN" },
            { label: "Rio Grande do Sul", value: "RS" },
            { label: "Rondônia", value: "RO" },
            { label: "Roraima", value: "RR" },
            { label: "Santa Catarina", value: "SC" },
            { label: "São Paulo", value: "SP" },
            { label: "Sergipe", value: "SE" },
            { label: "Tocantins", value: "TO" }
        ]

        return (
            <>
                <header className="header-create">
                    <img src="/images/logotipo_white.png" height="40" onClick={() => window.location.href = "/"} style={{ cursor: "pointer" }} />
                </header>
                <div className="page-cadastro">
                    <MDBRow>
                        <MDBCol md="12">
                            <h2 className="title-create-conta">Criar uma conta no FIPO</h2>
                            <p style={{ fontSize: "16px" }}>Preencha os dados da sua empresa para criar uma conta no FIPO. Você terá <b>5 dias</b> para avaliar o serviço.</p>
                        </MDBCol>

                        <MDBCol md="5">
                            <h4 className="sub_title">Dados da empresa</h4>
                            <FormGroup
                                className="form-group"
                                label="Nome da empresa (Razão Social) *">
                                <InputGroup type="text" value={LoginStore.obs.razao_social} onChange={(e: any) => LoginStore.obs.razao_social = e.target.value} className="input-email" />
                                <span className="non-valid">{this.obs.formErrors.razao_social}</span>
                            </FormGroup>

                            <FormGroup
                                className="form-group"
                                label="CNPJ *">
                                <div className={Classes.INPUT_GROUP}>
                                    <InputMask
                                      mask="99.999.999/9999-99"
                                      className="input-creates"
                                      style={{ width: "100%" }}
                                      onChange={(e) => {
                                        LoginStore.obs.cnpj = e.target.value
                                        LoginStore.buscaCNPJ(e.target.value);
                                      }}
                                    />
                                  </div>
                                <span className="non-valid">{this.obs.formErrors.cnpj}</span>
                            </FormGroup>

                            <FormGroup
                                className="form-group"
                                label="Telefone *">
                                <InputMask
                                    mask="(99) 99999-9999"
                                    className="input-creates"
                                    style={{ width: "100%" }}
                                    onChange={(e) => LoginStore.obs.telefone = e.target.value}
                                />
                                <span className="non-valid">{this.obs.formErrors.telefone}</span>
                            </FormGroup>

                        </MDBCol>

                        <MDBCol md="7">
                            <h4 className="sub_title">Dados de endereço</h4>
                            <MDBRow>
                                <MDBCol md="4">
                                    <FormGroup
                                        className="form-group"
                                        label="CEP *">
                                        <InputMask
                                            mask="99999-999"
                                            className="input-creates"
                                            style={{ width: "200px" }}
                                            onChange={(e) => this.handleCep(e.target.value)}
                                            value={LoginStore.obs.cep}
                                        />
                                        <span className="non-valid">{this.obs.formErrors.cep}</span>
                                    </FormGroup>
                                </MDBCol>
                                <MDBCol md="8">
                                    <FormGroup
                                        className="form-group"
                                        label="Rua *">
                                        <InputGroup type="text" onChange={(e: any) => LoginStore.obs.rua = e.target.value} className="input-email" value={LoginStore.obs.rua} />
                                        <span className="non-valid">{this.obs.formErrors.rua}</span>

                                    </FormGroup>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="4">
                                    <FormGroup
                                        className="form-group"
                                        label="Complemento">
                                        <InputGroup type="text" onChange={(e: any) => LoginStore.obs.complemento = e.target.value} className="input-email" value={LoginStore.obs.complemento} />
                                    </FormGroup>
                                </MDBCol>
                                <MDBCol md="5">
                                    <FormGroup
                                        className="form-group"
                                        label="Bairro *">
                                        <InputGroup type="text" onChange={(e: any) => LoginStore.obs.bairro = e.target.value} className="input-email" value={LoginStore.obs.bairro} />
                                        <span className="non-valid">{this.obs.formErrors.bairro}</span>

                                    </FormGroup>
                                </MDBCol>
                                <MDBCol md="3">
                                    <FormGroup
                                        className="form-group"
                                        label="Número *">
                                        <InputGroup type="text" onChange={(e: any) => LoginStore.obs.numero = e.target.value} className="input-email" value={LoginStore.obs.numero} />
                                        <span className="non-valid">{this.obs.formErrors.numero}</span>

                                    </FormGroup>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="6">
                                    <FormGroup
                                        className="form-group"
                                        label="Cidade *">
                                        <InputGroup type="text" onChange={(e: any) => LoginStore.obs.cidade = e.target.value} className="input-email" value={LoginStore.obs.cidade} />
                                        <span className="non-valid">{this.obs.formErrors.cidade}</span>

                                    </FormGroup>
                                </MDBCol>
                                <MDBCol md="6">
                                    <FormGroup
                                        className="form-group"
                                        label="Estado *">
                                        <HTMLSelect
                                            onChange={(e: any) => LoginStore.obs.estado = e.target.value}
                                            value={LoginStore.obs.estado}
                                            className="select-estados"
                                            disabled
                                        >
                                            {estadosOption?.map((option) => (
                                                <option value={option.value}>{option.label}</option>
                                            ))}
                                        </HTMLSelect>
                                        <span className="non-valid">{this.obs.formErrors.estado}</span>
                                    </FormGroup>

                                </MDBCol>

                            </MDBRow>
                        </MDBCol>
                        <MDBCol md="12">
                            <h4 className="sub_title">Dados do Representante Legal</h4>
                            <MDBRow>
                                <MDBCol md="8">
                                    <FormGroup
                                        className="form-group"
                                        label="Nome Completo *">
                                        <InputGroup type="text" onChange={(e: any) => LoginStore.obs.pessoa_nome = e.target.value} className="input-email" />
                                        <span className="non-valid">{this.obs.formErrors.pessoa_nome}</span>
                                    </FormGroup>
                                </MDBCol>
                                <MDBCol md="4">
                                    <FormGroup
                                        className="form-group"
                                        label="CPF *">
                                        <InputMask
                                            mask="999.999.999-99"
                                            className="input-creates"
                                            style={{ width: "100%" }}
                                            onChange={(e) => LoginStore.obs.pessoa_cpf = e.target.value}
                                            value={LoginStore.obs.pessoa_cpf}
                                        />
                                        <span className="non-valid">{this.obs.formErrors.pessoa_cpf}</span>
                                    </FormGroup>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="8">
                                    <FormGroup
                                        className="form-group"
                                        label="E-mail *">
                                        <InputGroup type="text" onChange={(e: any) => LoginStore.obs.pessoa_email = e.target.value} className="input-email" placeholder="email@email.com" />
                                        <span className="non-valid">{this.obs.formErrors.pessoa_email}</span>
                                    </FormGroup>
                                </MDBCol>
                                <MDBCol md="4">
                                    <FormGroup
                                        className="form-group"
                                        label="Data de Nascimento *">
                                        <InputMask
                                            mask="99/99/9999"
                                            className="input-creates"
                                            style={{ width: "100%" }}
                                            onChange={(e) => LoginStore.obs.pessoa_nascimeto = e.target.value}
                                            value={LoginStore.obs.pessoa_nascimeto}
                                        />
                                        <span className="non-valid">{this.obs.formErrors.pessoa_nascimeto}</span>
                                    </FormGroup>

                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="3">
                                    <FormGroup
                                        className="form-group"
                                        label="CEP *">
                                        <InputMask
                                            mask="99999-999"
                                            className="input-creates"
                                            style={{ width: "100%" }}
                                            onChange={(e) => this.handlePessoaCep(e.target.value)}
                                            value={LoginStore.obs.pessoa_cep}
                                        />
                                        <span className="non-valid">{this.obs.formErrors.pessoa_cep}</span>
                                    </FormGroup>
                                </MDBCol>
                                <MDBCol md="5">
                                    <FormGroup
                                        className="form-group"
                                        label="Rua *">
                                        <InputGroup type="text" onChange={(e: any) => LoginStore.obs.pessoa_rua = e.target.value} className="input-email" value={LoginStore.obs.pessoa_rua} />
                                        <span className="non-valid">{this.obs.formErrors.pessoa_rua}</span>
                                    </FormGroup>
                                </MDBCol>
                                <MDBCol md="4">
                                    <FormGroup
                                        className="form-group"
                                        label="Bairro *">
                                        <InputGroup type="text" onChange={(e: any) => LoginStore.obs.pessoa_bairro = e.target.value} className="input-email" value={LoginStore.obs.pessoa_bairro} />
                                        <span className="non-valid">{this.obs.formErrors.pessoa_bairro}</span>
                                    </FormGroup>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="3">
                                    <FormGroup
                                        className="form-group"
                                        label="Número *">
                                        <InputGroup type="text" onChange={(e: any) => LoginStore.obs.pessoa_numero = e.target.value} className="input-email" value={LoginStore.obs.pessoa_numero} />
                                        <span className="non-valid">{this.obs.formErrors.pessoa_numero}</span>
                                    </FormGroup>
                                </MDBCol>

                                <MDBCol md="5">
                                    <FormGroup
                                        className="form-group"
                                        label="Cidade *">
                                        <InputGroup type="text" onChange={(e: any) => LoginStore.obs.pessoa_cidade = e.target.value} className="input-email" value={LoginStore.obs.pessoa_cidade} />
                                        <span className="non-valid">{this.obs.formErrors.pessoa_cidade}</span>
                                    </FormGroup>
                                </MDBCol>
                                <MDBCol md="4">
                                    <FormGroup
                                        className="form-group"
                                        label="Estado *">
                                        <HTMLSelect
                                            onChange={(e: any) => LoginStore.obs.pessoa_estado = e.target.value}
                                            value={LoginStore.obs.pessoa_estado}
                                            className="select-estados"
                                        >
                                            {estadosOption?.map((option) => (
                                                <option value={option.value}>{option.label}</option>
                                            ))}
                                        </HTMLSelect>
                                        <span className="non-valid">{this.obs.formErrors.pessoa_estado}</span>
                                    </FormGroup>
                                </MDBCol>
                            </MDBRow>
                        </MDBCol>

                        <MDBCol md="12">
                            <h4 className="sub_title">Representante</h4>
                            <FormGroup
                                className="form-group"
                                label="Código do Representante">
                                <InputGroup type="text" onChange={(e: any) => LoginStore.obs.representante_id = e.target.value} className="input-email" />
                            </FormGroup>
                        </MDBCol>

                        <MDBCol md="12" style={{ marginBottom: "70px" }}>
                            <h4 className="sub_title">CONTRATO DE LICENÇA DE USO DE SOFTWARE FIPO E TERMO DE USO</h4>
                            <span style={{ fontSize: "16px" }}>Leia atentamente nossos termos e condições descritos abaixo. Após concordar, você poderá criar seu usuário.</span>
                            <div className="termos-textos">
                                <h4>1. PARTES CONTRATANTES</h4>
                                <p><b><b>FIPO</b> GERENCIADOR FISCAL E AUDITOR TRIBUTÁRIO</b>, pessoa jurídica de direito privado, inscrita no CNPJ/MF sob o nº 31.444.513/0001-15, com sede na cidade de Marabá, Estado do Pará, na Qd. Zero (Fl.28), n.19, 2º andar, Bairro Nova Marabá, CEP 68506-000, doravante denominada simplesmente "<b>FIPO</b>".</p>

                                <p><b>LICENCIDADO</b> é pessoa física ou jurídica que adquire o direito de usar o Software objeto do presente TERMO DE USO, por meio de assinatura digital ou no sítio <b>FIPO</b>.com.br.</p>

                                <h4>2. DECLARAÇÃO DE VONTADE</h4>
                                <p>2.1. O <b>LICENCIADO</b> DECLARA TER CIÊNCIA DOS DIREITOS E OBRIGAÇÕES DECORRENTES DO PRESENTE TERMO, CONSTITUINDO ESTE INSTRUMENTO O ACORDO COMPLETO ENTRE AS PARTES. DECLARA, AINDA, TER LIDO, COMPREENDIDO E ACEITO TODOS OS TERMOS E CONDIÇÕES DESTE INSTRUMENTO.</p>

                                <p>2.2. A partir do momento em que o <b>LICENCIADO</b> aceitar este TERMO, as disposições aqui constantes passam a valer entre a <b>FIPO</b> e o <b>LICENCIADO</b>, inclusive no período de teste conforme previsto no item 5.1, razão pela qual é recomendável que o <b>LICENCIADO</b> imprima uma cópia deste documento para futura referência.</p>

                                <p>2.3. O <b>LICENCIADO</b> se declara ciente de que as operações que corresponderem à aceitação de determinadas opções serão registradas nos bancos de dados da <b>FIPO</b>, juntamente com a data e hora em que o aceite foi manifestado pelo <b>LICENCIADO</b>, podendo tal informação ser utilizada como prova da aceitação da opção pelo <b>LICENCIADO</b>, independentemente de outra formalidade.</p>

                                <p>2.4 O LICENCIDADO reconhece que a relação jurídica estabelecida entre as partes é de natureza comercial, não se aplicando as regras do Código de Defesa do Consumidor.</p>

                                <p>2.5 O <b>LICENCIADO</b> declara que está ciente de sua responsabilidade exclusiva no lançamento de informações do usuário e/ou titular das dos dados da pessoa jurídica no cadastramento do banco de dados, ficando ciente que as informações lançadas erradas poderão alterar o resultado do cálculo tributário.</p>

                                <h4>3. OBJETO DO CONTRATO</h4>
                                <p>3.1 O presente contrato tem por objeto a licença de uso do Portal e/ou Software <b>FIPO</b> que faz a simulação de cálculo de tributos estaduais relativos à Fazenda Estadual do Estado do Pará para pessoas jurídicas.</p>

                                <p>3.2 Todas as operações no Portal da <b>FIPO</b> serão realizadas pelo <b>LICENCIADO</b> e/ou usuário do Software <b>FIPO</b> que as validará por meio de certificado digital e/ou login e senha.</p>

                                <h4>4. REMUNERAÇÃO E FORMA DE PAGAMENTO</h4>
                                <p>4.1 O <b>LICENCIADO</b>, no momento da contratação, escolherá um PLANO disponibilizado para cada cadastro de pessoa jurídica, cujo valor será mensal e de acordo com o faturamento mensal da pessoa jurídica cadastrada e a quantidade de MB de armazenamento necessários para lançamento das notas fiscais.</p>

                                <p>4.2 Caso o <b>LICENCIADO</b>, após a contratação do PLANO, opte por outro, os valores serão alterados de forma imediata e passará a ser devido na sua integralidade a partir do momento da sua migração e não de forma proporcional.</p>

                                <p>4.3 A falta de pagamento até 5 (cinco) dias corridos a contar da data do vencimento, escolhida no momento do cadastramento, acarretará a suspensão do direito de uso do Software até a regularização das pendencias financeiras, acrescidos de juros de 1% (um por cento) ao mês, multa compensatória de 2% (dois por cento) e correção monetária pelo variação do IGPM da Fundação Getúlio Vargas, sem prejuízo do estabelecido no item 5.2.</p>

                                <p>4.4 Caso a suspensão permaneça por prazo superior a 60 (sessenta dias), a <b>FIPO</b> poderá excluir integralmente as informações lançadas no Portal e/ou Software <b>FIPO</b>.</p>

                                <p>4.5 Os valores devidos por PLANO escolhido no momento do aceite do presente Termo serão cobrados de forma antecipada do LICENDIADO para uso no mês subsequente.</p>

                                <p>4.6 O valor do PLANO poderá ser reajustado pela <b>FIPO</b> a qualquer tempo, podendo o <b>LICENCIADO</b> não manter ou renovar o acesso ao Software <b>FIPO</b>. Neste caso, o acesso será suspenso findo o prazo de validade do pagamento que será no mês subsequente ao último pagamento.</p>

                                <p>4.7 A rescisão imotivada pelo <b>LICENCIADO</b> não exime a obrigação do pagamento dos serviços prestados e contratados, na forma do itens 5.3 e 5.4 deste TERMO DE USO.</p>

                                <p>4.8 O inadimplemento dos valores devidos à <b>FIPO</b> autoriza o registro do nome do devedor nos cadastros de inadimplência, bem como a cobrança extrajudicial e/ou judicial.</p>

                                <h4>5. PRAZO DE VIGÊNCIA DO CONTRATO E RESCISÃO</h4>
                                <p>5.1 A <b>FIPO</b> disponibilizará o período 5 (cinco) dias corridos grátis para teste do Software e que serão válidas as condições e responsabilidades estabelecidas neste TERMO DE USO.</p>

                                <p>5.2 Após o período de 5 (cinco) dias de teste, o presente contrato passará a valer a partir do momento do aceite dos termos e condições descritas no presente TERMO DE USO pelo prazo mínimo de 12 (doze) meses, com renovação automática e prorrogável por igual período.</p>

                                <p>5.3 Não será permitido o cancelamento do PLANO antes de 12 (meses). Caso seja suspenso o serviço por falta de pagamento na forma do item 4.3 será devido pelo LICENDIADO o valor correspondente ao período faltante para completar 12 (meses) com as penalidades e condições estabelecidas nos itens 4.3 e 4.4.</p>

                                <p>5.4 O <b>LICENCIADO</b> poderá, a qualquer momento, solicitar a rescisão do seu PLANO e CONTA de acesso ao portal <b>FIPO</b>, mediante solicitação no próprio portal/sítio da <b>FIPO</b>, sendo os serviços paralisados após o período de 24 horas, sem prejuízo do estabelecido no item 4.3 e 5.2.</p>

                                <p>5.5 A <b>FIPO</b> poderá suspender a utilização do Software, com aviso prévio de 30 dias ao <b>LICENCIADO</b>, sem qualquer ônus para qualquer das partes.</p>

                                <p>5.6 A <b>FIPO</b> poderá modificar as condições e responsabilidades deste contrato mediante aviso no portal/sítio de acesso do <b>LICENCIADO</b>.</p>

                                <p>5.7 Com o encerramento do PLANO por qualquer das partes, será concedido prazo de 60 (sessenta) dias corridos para o <b>LICENCIADO</b> fazer downloads de todas as informações lançadas no Software.</p>

                                <p>5.8 Não será permitido a portabilidade das informações para outro Software que não seja de titularidade da <b>FIPO</b>.</p>

                                <p>5.9 O armazenamento de dados no Software <b>FIPO</b> se dará pelo período de 6 (seis) meses a partir do seu lançamento, em conformidade com as exigências do Marco Civil da Internet.</p>

                                <p>5.10 A <b>FIPO</b> assegura que, encerrada a relação contratual ou revogado o consentimento para tratamento dos dados, as informações lançadas no Portal e/ou Software serão eliminadas, ressalva feita à manutenção dos registros necessários ao cumprimento de dever legal ou para eventual defesa e processos judiciais ou administrativos.</p>
                                <h4>6. INFORMAÇÕES CONFIDENCIAIS E POLÍTICA DE SEGURANÇA DO USUÁRIO</h4>

                                <p>6.1. A <b>FIPO</b> se compromete a manter a confidencialidade, integridade e em segurança as informações lançadas no Portal e/ou Software <b>FIPO</b> pelo <b>LICENCIADO</b> relacionadas a seus Usuários e/ou Equipamentos de TI.</p>

                                <p>6.2. Com a finalidade de garantir a privacidade do <b>LICENCIADO</b>, bem como a segurança de suas Informações, a <b>FIPO</b> se compromete a regularmente reavaliar a sua política de segurança e adaptá-la, conforme necessário.</p>

                                <p>6.3. A <b>FIPO</b> não irá vender ou disponibilizar as informações do <b>LICENCIADO</b> lançadas no Portal e/ou Software <b>FIPO</b>, com exceção das que o <b>LICENCIADO</b> expressamente concorda e anui neste ato:</p>

                                <p>a) Para enviar ao <b>LICENCIADO</b> qualquer notificação administrativa, alertas e comunicados relevantes para o mesmo;</p>

                                <p>b) Para cumprir com a finalidade do Portal e/ou Software <b>FIPO</b>;</p>

                                <p>c) Identificar o perfil, desejos ou necessidades do <b>LICENCIADO</b> a fim de aprimorar os produtos e/ou serviços oferecidos no Portal <b>FIPO</b> e/ou Software <b>FIPO</b>;</p>

                                <p>d) Realizar estatísticas genéricas para monitoramento de utilização do Portal e/ou Software <b>FIPO</b>;</p>

                                <p>e) Para pesquisas de marketing, planejamento de projetos da <b>FIPO</b> e fins estatísticos;</p>

                                <p>f) Autoriza a <b>FIPO</b> acesso às contas e aos dados do LICENCIDADO e/ou usuário para resolução de problemas no Portal e/ou Software <b>FIPO</b>, verificação e proteção das informações lançadas contra erros, fraudes ou qualquer outro crime eletrônico;</p>

                                <p>g) Autoriza a <b>FIPO</b> o acesso da conta e dados do LICENCIDADO e/ou usuário para resolução de problemas no Portal e/ou Software <b>FIPO</b> e suporte técnico</p>

                                <p>6.4. Caso haja qualquer alteração de dados do usuário e/ou <b>LICENCIADO</b>, especialmente relativas às questões fiscais, o LICENDIADO deve lançar imediatamente as alterações no cadastramento do Portal e/ou Software <b>FIPO</b> de modo a garantir o melhor resultado do simulador do cálculo fiscal.</p>

                                <p>6.5. As Informações do <b>LICENCIADO</b> poderão ser transferidas a terceiros em decorrência da venda, aquisição, fusão, reorganização societária ou qualquer outra mudança no controle da <b>FIPO</b>. Caso ocorra qualquer destas hipóteses, no entanto, resultando na transferência das Informações a terceiros, o <b>LICENCIADO</b> será informado previamente e caso não deseje prosseguir com a utilização do Software <b>FIPO</b>, poderá excluir sua conta de acesso na forma prevista nos itens 5.7, 5.8, 5.9 e 5.10 deste TERMO DE USO. Nesta hipótese, as Informações do <b>LICENCIADO</b> serão apagadas do banco de dados da <b>FIPO</b> e não serão transmitidas a terceiros.</p>

                                <p>6.6. Não obstante as Informações fornecidas pelo <b>LICENCIADO</b> estejam seguras nos termos deste TERMO DE USO, o login e a senha de acesso ao Portal e/ou Software <b>FIPO</b> são confidenciais e de responsabilidades exclusiva do <b>LICENCIADO</b>.</p>

                                <p>6.7. Caso o <b>LICENCIADO</b> acredite que seu login e senha de acesso ao Portal tenham sido roubados ou sejam de conhecimento de outras pessoas, por qualquer razão, o <b>LICENCIADO</b> deverá imediatamente comunicar a <b>FIPO</b> na forma prevista no Item 12  deste TERMO DE USO, sem prejuízo da alteração de senha imediata por meio do Portal <b>FIPO</b>.</p>
                                <h4>7. NÍVEL DE SERVIÇO</h4>

                                <p>7.1. A <b>FIPO</b> empreenderá esforços comercialmente razoáveis para tornar o Portal e/ou Software <b>FIPO</b> disponível, no mínimo, 99% (noventa e nove por cento) durante cada ano.</p>

                                <p>7.2 O Compromisso de Nível de Serviço não se aplica às circunstâncias de indisponibilidade que resultem:</p>

                                <p>a) De uma interrupção do fornecimento de energia elétrica ou paradas emergenciais não superiores a 6 (seis) horas para soluções técnicas entre outros ou que ocorram no período das 00:00h até às 6:00h;</p>

                                <p>b) Forem causadas por fatores que fujam do controle da <b>FIPO</b>, inclusive casos de força maior ou de acesso à Internet e problemas correlatos;</p>

                                <p>c) De quaisquer atos ou omissões do <b>LICENCIADO</b> ou de terceiros;</p>

                                <p>d) Do equipamento de TI, software ou outras tecnologias que o <b>LICENCIADO</b> usar e/ou do equipamento de TI que impeçam o acesso regular ao Portal e/ou Software <b>FIPO</b>;</p>

                                <p>e) De falhas de instâncias individuais não atribuíveis à indisponibilidade do <b>LICENCIADO</b>.</p>

                                <p>7.3 O <b>LICENCIADO</b> deverá notificar a <b>FIPO</b> imediatamente no caso de falhas no uso do Software sobre eventos adversos, graves ou inesperados associados ao uso do mesmo.</p>

                                <h4>8. OBRIGAÇÕES DA <b>FIPO</b></h4>
                                <p>8.1 Fornecer o acesso ao Portar e Software <b>FIPO</b> de acordo com o PLANO escolhido pelo LICENCIDADO por meio de Login e Senha;</p>

                                <p>8.2 Auxiliar o <b>LICENCIADO</b> na solução de dúvidas existentes a respeito do Software <b>FIPO</b>;</p>

                                <p>8.3 Corrigir qualquer erro ou defeito relatado pelo <b>LICENCIADO</b> que seja referente ao software <b>FIPO</b>.</p>

                                <h4>9. OBRIGAÇÕES DO <b>LICENCIADO</b></h4>
                                <p>9.1 Lançar as informações corretas quando do cadastramento da pessoa jurídica no item “Dados da Empresa”, especialmente relativas ao enquadramento fiscal do usuário e/ou titular <b>LICENCIADO</b>, de modo que a <b>FIPO</b> não se responsabiliza pela simulação errado do cálculo;</p>

                                <p>9.2 Auxiliar e cooperar com a <b>FIPO</b>, quando for necessário, na análise e solução de erros, casos existentes, no Software <b>FIPO</b>;</p>

                                <p>9.3 Responsabilizar-se exclusivamente na elaboração de cópias de salvaguarda (backup) e demais medidas de proteção de seus dados e informações armazenadas em banco de dados, se existente;</p>

                                <p>9.4 Fornecer à <b>FIPO</b>, quando solicitado, todos equipamentos, dados e informações relevantes para viabilizar e facilitar a prestação dos serviços de manutenção, atualização e, caso necessário, suporte técnico;</p>

                                <p>9.5 É de responsabilidade do usuário manifestar confirmação de operação de cada Nota Fiscal lançada no sítio do <b>https://www.nfe.fazenda.gov.br/portal/manifestacaoDestinatario.aspx?tipoConteudo=z+xSrb/veGA=</b> especialmente para verificação da legalidade das Notas Fiscais;</p>

                                <p>9.6 O <b>LICENCIADO</b> deve fazer downloads diários, assim, em caso de rescisão contratual, não haverá obrigatoriedade de entrega de dados por partes da <b>FIPO</b>, sendo de responsabilidade exclusiva do <b>LICENCIADO</b> armazenar os dados de back-up que tenham sidos disponibilizados no Portal da <b>FIPO</b>.</p>

                                <h4>10. RESPONSABILIDADE DA <b>FIPO</b></h4>
                                <p>10.1. A <b>FIPO</b> NÃO responderá, em nenhuma hipótese, ainda que em caráter solidário ou subsidiário:</p>

                                <p>a) Por eventuais prejuízos sofridos pelo <b>LICENCIADO</b> em razão das informações lançadas erradas, em especial no cadastramento da pessoa jurídica e notas fiscais, e relativas ao uso e mau uso do Portal e/ou Software <b>FIPO</b>;</p>

                                <p>b) Por eventuais prejuízos sofridos pelo <b>LICENCIADO</b> em razão de falhas no sistema de informática ou nos servidores que independam de culpa da <b>FIPO</b> ou em sua conectividade com a internet de modo geral, devendo o <b>LICENCIADO</b> manter, às suas expensas, linha de telecomunicação, modem, software de comunicação, endereço de correio eletrônico e outros recursos necessários à comunicação com a <b>FIPO</b>;</p>

                                <p>c) Por situações de caso fortuito ou força maior, nos termos do artigo 393 do Código Civil Brasileiro.</p>

                                <p>10.2. A <b>FIPO</b> não garante que as funções contidas no Software atendam às suas necessidades, que a operação do Portal será ininterrupta ou livre de erros, que qualquer funcionalidade continuará disponível, que os defeitos serão corrigidos ou que funcione com qualquer tipo de tecnologia, aplicações ou serviços de terceiros.</p>

                                <p>10.3 Em nenhum caso a <b>FIPO</b> será responsável por danos pessoais ou qualquer prejuízo incidental, especial, indireto ou consequente, lucros cessantes, incluindo, sem limitação, prejuízos por perda de lucro, corrupção ou perda de dados, falha de transmissão ou recepção de dados, não continuidade do negócio ou qualquer outro prejuízo ou perda comercial, decorrentes ou relacionados ao seu uso ou sua inabilidade em usar o Portal e/ou Software, por qualquer outro motivo.</p>

                                <p>10.4 A <b>FIPO</b> não é responsável por danos decorrentes do mau uso ou inabilidade do <b>LICENCIADO</b> em transmitir, receptar, inserir e extrair informações do Software.</p>

                                <p>10.5 A <b>FIPO</b> não é responsável por danos sofridos pelo <b>LICENCIADO</b> relativos a interpretação da legislação fiscal regulatória, fiscal-tributária, uso do Software e informações do negócio e fatos geradores de tributos nele inserida.</p>

                                <p>10.6 A <b>FIPO</b> não se responsabiliza pela integração desautorizada do Software com outros Softwares e/ou ambiente computacional do licitante que possam gerar ineficiência ou distorções de dados.</p>

                                <p>10.7 A <b>FIPO</b> não se responsabiliza pelo resultado do cálculo tributário, pois o Software trata-se e simulador de cálculo fiscal na legislação Estadual no Estado do Pará, o qual deverá ser sempre objeto de conferencia pelo <b>LICENCIADO</b> usuário.</p>

                                <h4>11. MODIFICAÇÕES</h4>
                                <p>11.1 A <b>FIPO</b> poderá, a qualquer tempo, alterar este TERMO de uso com o fim de se adequar a legislação e ao produto, inclusive para ajustar valores dos Planos.</p>

                                <p>11.2 Quaisquer alterações neste TERMO DE USO serão informadas por meio do Portal <b>FIPO</b> e serão disponibilizadas previamente à contratação dos serviços.</p>

                                <p>11.3 Será sempre indicada a data da última atualização realizada pela <b>FIPO</b> no TERMO.</p>

                                <p>11.4. O <b>LICENCIADO</b> entende e concorda que, assim que publicada a alteração deste TERMO DE USO no Portal <b>FIPO</b>, o uso do Portal e/ou Software <b>FIPO</b> passa a ser submetido ao TERMO atualizado.</p>

                                <h4>12. DO ACESSO AO APLICATIVO</h4>
                                <p>12.1. Este Termo concede ao <b>LICENCIADO</b> uma licença revogável, onerosa, não exclusiva e intransferível de uso do Portal e/ou Software <b>FIPO</b>, sendo certo que o <b>LICENCIADO</b> não poderá utilizar e nem permitir o uso para qualquer outra finalidade não expressamente prevista neste instrumento.</p>

                                <p>12.2. Por meio do Aplicativo o <b>LICENCIADO</b>, entre outros, terá acesso a uma ferramenta para simular cálculos fiscais estaduais de ICMS antecipado conforme legislação do Estado do Pará.</p>

                                <p>12.3. Para tanto, o <b>LICENCIADO</b> realizará o seu cadastro no Portal, fornecendo as suas Informações de Cadastro que serão utilizados para acesso ao Portal e/ou Software <b>FIPO</b>.</p>

                                <p>12.4. O <b>LICENCIADO</b> é responsável pela veracidade, validade e precisão das informações por ele fornecidas no seu cadastro, inclusive em relação à indicação de endereço de e-mail válido de sua titularidade, competindo-lhe, ainda, manter referido cadastro sempre atualizado.</p>

                                <p>12.5. A <b>FIPO</b> não terá qualquer obrigação de policiar ou fiscalizar as informações fornecidas pelo <b>LICENCIADO</b>, mas poderá, ao seu exclusivo critério, notificar o <b>LICENCIADO</b> quando verificar algum tipo de irregularidade nas informações lançadas.</p>

                                <p>12.6. O login e senhas criados pelo <b>LICENCIADO</b> para acesso ao Aplicativo são confidenciais e de responsabilidade exclusiva do <b>LICENCIADO</b>, que deverá entrar em contato com a <b>FIPO</b>, imediatamente, na hipótese de comprometimento do seu sigilo.</p>

                                <p>12.7. O <b>LICENCIADO</b> poderá, a qualquer tempo, realizar o cadastramento de usuários vinculados à sua conta. Uma vez cadastrados, esses usuários poderão acessar, modificar, incluir e excluir dados de sua conta, inclusive, podendo nomear outros usuários. Desta forma, o <b>LICENCIADO</b> isenta a <b>FIPO</b> de qualquer informação acessada, modificada, incluída ou excluída pelos usuários cujo acesso foi concedido exclusivamente pelo <b>LICENCIADO</b>.</p>

                                <h4>13. DISPOSIÇÕES GERAIS</h4>
                                <p>13.1. Este TERMO DE USO não gera nenhum contrato de sociedade, de mandato, franquia ou relação de trabalho entre a <b>FIPO</b> e o <b>LICENCIADO</b>, seus Parceiros e/ou Anunciantes.</p>

                                <p>13.2. Caso qualquer disposição deste TERMO DE USO for considerada ilegal, nula ou inexequível por qualquer razão, as restantes disposições não serão afetadas e manter-se-ão válidas e aplicáveis na máxima extensão possível.</p>

                                <p>13.3. Este TERMO DE USO constitui a totalidade do acordo sobre as condições de uso do Portal e do Software <b>FIPO</b>.</p>

                                <p>O <b>LICENCIADO</b> declara ter ciência dos direitos e obrigações decorrentes do presente TERMO DE USO, tendo lido, compreendido e aceito todos os termos e condições.</p>

                                <p>13.4. Qualquer falha da <b>FIPO</b> para impor ou exercer qualquer disposição deste TERMO DE USO ou direitos conexos, não constitui uma renúncia a esse direito ou disposição.</p>

                                <p>13.5. A tolerância de uma parte para com a outra quanto ao descumprimento de qualquer uma das obrigações assumidas neste contrato não implicará em novação ou renúncia de direito. A parte tolerante poderá, a qualquer tempo, exigir da outra parte o fiel e cabal cumprimento deste contrato.</p>

                                <p>13.6. O <b>LICENCIADO</b> concorda que a <b>FIPO</b> possa divulgar o fechamento contrato para fins comerciais, fazendo menção ao nome e à marca do <b>LICENCIADO</b> em campanhas comerciais, podendo, inclusive, divulgar mensagens enviadas de forma escrita ou oral, por telefone, para uso em sites, jornais, revistas e outras campanhas, enquanto vigorar o presente TERMO.</p>

                                <p>O <b>LICENCIADO</b> aceita, ainda, receber notificações via correio eletrônico sobre treinamentos, parcerias e campanhas relacionadas ao Aplicativo.</p>

                                <h4>14. LEI E FORO APLICÁVEIS</h4>
                                <p>14.1. Este TERMO DE USO será interpretado exclusivamente segundo as leis do Brasil.</p>

                                <p>14.2. As partes elegem o Foro da Comarca de Marabá, Estado do Pará, como o único competente para dirimir qualquer litígio resultante deste TERMO.</p>

                                <p>14.3. Este TERMO DE USO constitui a totalidade do acordo sobre as condições de uso do Portal e do Aplicativo. O <b>LICENCIADO</b> declara ter ciência dos direitos e obrigações decorrentes do presente, tendo lido, compreendido e aceito todos os termos e condições.</p>

                                <p>
                                    Marabá, Estado do Pará, em 21/6/2023.
                                </p>

                            </div>


                            <label
                                style={{ fontSize: "16px" }}
                            >
                                <input
                                    type="checkbox"
                                    checked={LoginStore.obs.termos}
                                    onChange={() => (LoginStore.obs.termos = !LoginStore.obs.termos)}
                                />
                                &nbsp;&nbsp;Li e concordo com os termos acima.
                            </label>
                            <br />
                            <label
                                style={{ fontSize: "16px" }}
                            >
                                <input
                                    type="checkbox"
                                    checked={LoginStore.obs.acomar}
                                    onChange={() => (LoginStore.obs.acomar = !LoginStore.obs.acomar)}
                                />
                                &nbsp;&nbsp;Empresa associada Acomar
                            </label>

                            <div className="submit-panel">
                                {!this.obs.loading
                                    ? <Button className="btn btn-submit submit-etapa" disabled={!LoginStore.obs.termos} onClick={() => this.handleContinuar()}>Continuar</Button>
                                    : <Button className="btn btn-submit submit-etapa" disabled={!LoginStore.obs.termos}>
                                        <i className="fa fa-spinner fa-spin"></i>
                                        Carregando
                                    </Button>
                                }
                                <h2 className="title-sec">
                                    Na próxima etapa, você criará um usuário para sua conta
                                </h2>
                            </div>
                        </MDBCol>

                    </MDBRow>
                </div>

              <Dialog
                isOpen={LoginStore.obs.isBlock}
                onClose={() => LoginStore.obs.isBlock = false}
                title="Aviso Importante!"
                className="modal-loading"
              >
                <div className={Classes.DIALOG_BODY}>
                  O sistema está disponível exclusivamente para empresas localizadas no estado do Pará (PA).
                  <br />
                  <br />
                  Em caso de dúvidas, entre em contato conosco pelo telefone:{" "}
                  <a target="_blank" href="https://web.whatsapp.com/send?phone=5554920004300&text=Olá, FIPO! Sou de outro estado e gostaria de testar o sistema. Poderiam me auxiliar?"><b>(54) 99189-3928</b></a> 
                  {" "}ou pelo{" "}
                  <b><a target="_blank" href="https://www.instagram.com/fipoicmsantecipado/?igsh=ZXRtcmZyM21udzhv">Instagram</a></b>
                </div>
              </Dialog>
            </>
        );
    }
}

export default CreateContaPage;
